<template>
    <el-row type="flex" justify="center">
        <el-col :span="6">
            <div style="text-align: center">
                <h1>404</h1>
                <p>Not Found</p>
            </div>
        </el-col>
    </el-row>
</template>

<script>
    export default {
        name: 'NotFound',
    };
</script>

<style scoped>
    h1 {
        font-size: 34px;
        color: red;
        margin-bottom: 2rem;
    }
</style>



// WEBPACK FOOTER //
// src/components/pages/404/NotFound.vue